// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2CxlC","rootCenter":"LoadMoreObserver_rootCenter__3KRJC","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__14Xt-"};